import React from 'react';
import { Helmet } from 'react-helmet-async'; // oppure 'react-helmet' se non usi la versione async

function PageMeta({ 
  title = 'Titolo di default', 
  description = 'Descrizione di default', 
  image = "", 
  url = "",
  type = ""
}) {
  return (
    <Helmet>
      {/* Titolo del documento */}
      <title>{title}</title>

      {/* Meta SEO */}
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      {url   && <meta property="og:url"   content={url} />}
      <meta property="og:type" content={type} />
      <meta property="fb:app_id" content="227150527411739" />

      {/* Twitter Card */}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}

export default PageMeta;
